/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Multiview_OptionsInputs */



/**
* | output |
* | --- |
* | "Multiview Options" |
*
* @param {Multiview_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const multiview_options = /** @type {((inputs?: Multiview_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Multiview_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Options multivues")
	if (locale === "de") return /** @type {LocalizedString} */ ("Multiview-Optionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzioni multivista")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Параметры многооконного просмотра")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opciones de vista múltiple")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("多视图选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マルチビューオプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मल्टीव्यू विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opções de visualização múltipla")
	return /** @type {LocalizedString} */ ("Multiview Options")
});